import { render, staticRenderFns } from "./CompanyDownloadSelector.vue?vue&type=template&id=13bc8440&scoped=true"
import script from "./CompanyDownloadSelector.vue?vue&type=script&lang=js"
export * from "./CompanyDownloadSelector.vue?vue&type=script&lang=js"
import style0 from "./CompanyDownloadSelector.vue?vue&type=style&index=0&id=13bc8440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bc8440",
  null
  
)

export default component.exports